import { resourceTypeWithOperatorAutoCompete } from "@/components/pages/common/filters/kubernetes-filters/filters-selection/filter-by-type/utils/constants";

export const autocompleteFilterTypes: Set<string> = new Set([
  "resource_group",
  "creator",
  "status",
  "capacity_mode",
  "instance_type",
  "node_type",
  "storage_type",
  "instance_family",
  "provider_unique_identifier",
  "type",
  "name",
  "snapshot_id",
  "source_name",
  "storage_tier",
  "volume_id",
  "snapshot_status",
  "table",
  "protected_by",
  "ebs_optimized",
  "ip_addresses",
  "vpc",
  "nat_gateway_id",
  "capacity_provider",
  "public_access",
  "namespace",
  "table_class",
  "region",
  "platform",
  ...resourceTypeWithOperatorAutoCompete,
]);
